// removed by extract-text-webpack-plugin
module.exports = {"section":"user-shared-data-form__section-d4mdt","label":"user-shared-data-form__label-2LGQl","twoLineLabel":"user-shared-data-form__twoLineLabel-tUX-J","title":"user-shared-data-form__title-3LltT","field":"user-shared-data-form__field-2QBvJ","asterisk":"user-shared-data-form__asterisk-1l7hq","fieldset":"user-shared-data-form__fieldset-2jdwn","radioButton":"user-shared-data-form__radioButton-3AAZX"};


//////////////////
// WEBPACK FOOTER
// ./components/common/user/user-shared-data-form/user-shared-data-form.css
// module id = 134
// module chunks = 0